import {createSlice} from '@reduxjs/toolkit';

const initialState = {
    branding : {},
    theme_bg_color: "",
    logo: "/interview/interview-theme/images/logo.svg",
};

const brandingSlice = createSlice({
    name:'branding',
    initialState,
    reducers : {
        setBranding : (state, {payload}) => {
            state.branding = payload;
        },
        setThemeBgColor : (state, {payload}) => {
            state.theme_bg_color = payload;
        },
        setLogo : (state, {payload}) => {
            state.logo = payload;
        },
    }
})

export const {setBranding, setThemeBgColor, setLogo} = brandingSlice.actions;

export const getBranding = (state) => state.branding.branding;
export const getThemeBgColor = (state) => state.branding.theme_bg_color;
export const getLogo = (state) => state.branding.logo;

export default brandingSlice.reducer;